import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "history-list border-top border-outline-color" }

import { onBeforeUnmount, onMounted } from "vue";
import { PointHistory } from "@/types/worker/PointHistory";
import PointHistoryCard from "@/components/organisms/mypage/PointHistoryCard.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'PointHistoryList',
  props: {
    pointHistoryList: {}
  },
  emits: ["scrollToBottom"],
  setup(__props: any, { emit: emits }) {

const props = __props;




onMounted(() => {
  window.addEventListener("scroll", onScroll);
});

onBeforeUnmount(() => {
  window.removeEventListener("scroll", onScroll);
});

const onScroll = () => {
  if (
    // 最下部スクロール時
    Math.ceil(window.innerHeight + window.scrollY) >= document.body.offsetHeight
  ) {
    emits("scrollToBottom");
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("ul", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pointHistoryList, (history) => {
        return (_openBlock(), _createElementBlock("li", {
          key: history.id
        }, [
          _createVNode(PointHistoryCard, { pointHistory: history }, null, 8, ["pointHistory"])
        ]))
      }), 128))
    ])
  ]))
}
}

})